
  // Focus goes to the search box when its chip is removed, and LiveView leaves the value of a
  // focused input alone when a patch lands (the server's empty value only reaches an input the
  // user hasn't typed in). So the box is emptied here, before the patch. The server can't do it
  // alone: `JS.set_attribute` sets the attribute, not the value, and `phx-patch-focused` would
  // also overwrite text typed while a change event is on its way.
  export default {
    mounted() {
      this.el.addEventListener("click", (event) => {
        const selector = event.target.closest("[data-clears]")?.dataset.clears
        if (selector) document.querySelector(selector).value = ""
      })
    }
  }
